import { render, staticRenderFns } from "./DialogPortTrees.vue?vue&type=template&id=2082b908&scoped=true&"
import script from "./DialogPortTrees.vue?vue&type=script&lang=js&"
export * from "./DialogPortTrees.vue?vue&type=script&lang=js&"
import style0 from "./DialogPortTrees.vue?vue&type=style&index=0&id=2082b908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082b908",
  null
  
)

export default component.exports